import React from 'react';
import styled from 'styled-components';

const NoticeContainer = styled.div`
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  border: 1px solid #FFB74D;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 4px rgba(255, 183, 77, 0.2);
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FF9800;
  color: white;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
`;

const MessageContainer = styled.div`
  flex: 1;
`;

const Title = styled.div`
  font-weight: 600;
  color: #E65100;
  margin-bottom: 4px;
  font-size: 14px;
`;

const Description = styled.div`
  color: #BF360C;
  font-size: 13px;
  line-height: 1.4;
`;

const BackendOfflineNotice = ({ message }) => {
  return (
    <NoticeContainer>
      <IconContainer>
        ⚠️
      </IconContainer>
      <MessageContainer>
        <Title>Working in Local Mode</Title>
        <Description>
          {message || 'Backend server is temporarily unavailable. Your data is being saved locally and will sync when the connection is restored.'}
        </Description>
      </MessageContainer>
    </NoticeContainer>
  );
};

export default BackendOfflineNotice; 